import React from 'react';

const StudentsUnion = () => {
  return (
    <div>
      StudentsUnion
      StudentsUnion
    </div>
  );
}

export default StudentsUnion;
